import CylinderBreakingTestPage from './CylinderBreakingTestPage';
import CylinderBreakingTestUpdatePage from './CylinderBreakingTestUpdatePage';
import NewBreakingSchedulePage from './NewBreakingSchedulePage';
import QAQCAreaPage from './QAQCAreaPage';
import BreakingSchedulesPage from './QAQCAreaPage/BreakingSchedulePage';
import QAQCReportPage from './QAQCReportPage';

const qaqcModule = {
  pages: [
    QAQCAreaPage,
    NewBreakingSchedulePage,
    BreakingSchedulesPage,
    CylinderBreakingTestPage,
    CylinderBreakingTestUpdatePage,
    QAQCReportPage,
  ],
};

export default qaqcModule;
